import React from "react";
import { Icon, IconifyIcon } from "@iconify/react";
import arrowLeftFill from "@iconify/icons-eva/arrow-left-fill";
import arrowRightFill from "@iconify/icons-eva/arrow-right-fill";
import roundKeyboardArrowLeft from "@iconify/icons-ic/round-keyboard-arrow-left";
import roundKeyboardArrowRight from "@iconify/icons-ic/round-keyboard-arrow-right";
// material
import { useTheme, styled } from "@mui/material/styles";
import { Box } from "@mui/material";
//
import { MIconButton } from "../../@material-extend";
import { MUIStyledCommonProps } from "@mui/system";
import { CustomTheme } from "@admin/types";

const SIZE = 45;

const ICON_SIZE = {
  width: 30,
  height: 30,
};

const RootStyle = styled(Box)(({ theme }) => ({
  top: 0,
  bottom: 0,
  zIndex: 9,
  height: SIZE,
  width: "100%",
  margin: "auto",
  display: "flex",
  position: "absolute",
  padding: theme.spacing(0, 2),
  justifyContent: "space-between",
}));

const ArrowStyle = styled(MIconButton)(
  ({ theme }: MUIStyledCommonProps<CustomTheme>) => ({
    width: SIZE,
    height: SIZE,
    opacity: 0.78,
    display: "flex",
    cursor: "pointer",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.common.white,
    // background: theme.palette.grey[900],
    borderRadius: theme.shape.borderRadiusSm,
    transition: theme.transitions.create("opacity"),
    "&:hover": {
      opacity: 1,
      background: theme.palette.grey[900],
    },
  })
);

interface Props {
  arrowLine?: boolean;
  onNext?: () => void;
  onPrevious?: () => void;
  nextIcon?: IconifyIcon;
  prevIcon?: IconifyIcon;
}

export default function CarouselControlsArrowsBasic2({
  arrowLine,
  onNext,
  onPrevious,
  nextIcon,
  prevIcon,
  ...other
}: Props) {
  const theme = useTheme();
  const isRTL = theme.direction === "rtl";

  return (
    <RootStyle {...other}>
      <ArrowStyle size="small" onClick={onPrevious}>
        {arrowLine ? (
          <Icon
            icon={isRTL ? roundKeyboardArrowRight : roundKeyboardArrowLeft}
            {...ICON_SIZE}
          />
        ) : (
          <Icon
            icon={prevIcon != null ? prevIcon : arrowRightFill}
            {...ICON_SIZE}
          />
        )}
      </ArrowStyle>

      <ArrowStyle size="small" onClick={onNext}>
        {arrowLine ? (
          <Icon
            icon={isRTL ? roundKeyboardArrowLeft : roundKeyboardArrowRight}
            {...ICON_SIZE}
          />
        ) : (
          <Icon
            icon={nextIcon != null ? nextIcon : arrowLeftFill}
            {...ICON_SIZE}
          />
        )}
      </ArrowStyle>
    </RootStyle>
  );
}
